<template>
	<div class="sf-input-group-wrapper">
		<span class="sf-input-group-wrapper__label">{{ getMessage_('SWCC000002') }}</span>
		<div class="search-option-wrapper__normal">
			<el-select
				:value="searchParams.plantCd"
				:placeholder="getMessage_('SWCC000002')"
				style="height: 40px"
				@change="
					value => {
						return setSearchParam_({ key: 'plantCd', value: value });
					}
				"
			>
				<el-option v-for="(plant, index) in plants" :label="plant.commCdName" :value="plant.commCd" :key="index"></el-option>
			</el-select>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/UserGroupMap/store/helpers';
export default {
	data() {
		return {
			data: null
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods
	}
};
</script>

<style></style>
